let listItem = $('.faq-list__item');
let viewAll = $('.faq-list__view-all > span');
let search = $('.search-field');
let postsWrapper = $('.faq-list__term-wrapper');
search.keyup(function () {

    let filter = $(this).val();
    console.log(filter.length);

    if (filter.length > 0) {
        $(".faq-list__view-all").hide();
        $('.faq-list__item').each(function () {
            if ($(this).text().search(new RegExp(filter, "i")) <= 0) {
                $(this).hide();
            } else {
                $(this).show();
            }
        });

        postsWrapper.each(function () {
            if ($(this).find('.faq-list__posts-wrapper').children(':visible').length === 0) {
                $(this).find('.faq-list__term-title').hide();
            } else {
                $(this).find('.faq-list__term-title').show();
            }
        });
    } else {
        $(".faq-list__view-all").show()
        $('.faq-list__item').show();
        $('.faq-list__item.hide').hide();
        postsWrapper.each(function () {
            $(this).find('.faq-list__term-title').show();
        });
    }
    if (postsWrapper.find('.faq-list__posts-wrapper').children(':visible').length === 0
    ) {
        $('.faq-list__no-posts').show();
    } else {
        $('.faq-list__no-posts').hide();
    }

});




listItem.click(function () {
    $(this).children('.item__content').toggleClass('opened');
    $(this).children('.item__title').toggleClass('opened');
    $(this).toggleClass('opened');
    if ($(this).siblings().hasClass('opened')) {
        $(this).siblings().removeClass('opened');
        $(this).siblings().children('.item__content').removeClass('opened');
        $(this).siblings().children('.item__title').removeClass('opened');
    }
});

viewAll.click(function () {
    $(this).parent().siblings('.faq-list__posts-wrapper').find('.faq-list__item.hide').toggle();
    $(this).toggleHtml(translations.viewAll, translations.hide).toggleClass('show');
})




// WEBPACK FOOTER //
// ./scripts/modules/faq.js